import { GetStaticProps, NextPage } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { observer } from 'mobx-react'
import { MyHead } from '@/components/molecules/MyHead'
import { VerticalNavDefaultPageTemplate } from '@/components/templates/VerticalNavDefaultPageTemplate'
import { ColoredPageHeading } from '@/components/molecules/ColoredPageHeading'
import { AdFormat } from '@/components/molecules/AdFormat'
import { AdContactBtnGroup } from '@/components/molecules/AdContactBtnGroup'
import { AdInqueryFormModal } from '@/components/organisms/AdInqueryFormModal'
import styles from './index.module.scss'

const AdInquiry: NextPage = observer(() => {
  return (
    <VerticalNavDefaultPageTemplate>
      <MyHead title='AQA Ads' />
      <div className={styles.container}>
        <div className={styles.heading}>
          <ColoredPageHeading heading='AQA Ads'>
            <p className={styles.headingText}>
              Leverage the advertising function of AQA to supercharge your marketing and PR efforts, reaching a targeted
              audience of web3 enthusiasts and industry professionals to elevate your brand&apos;s visibility and
              impact.
            </p>
          </ColoredPageHeading>
        </div>
        <div className={styles.body}>
          <div className={styles.content}>
            <AdFormat
              title='Image Ads'
              text={`Highlight your best creative and drive people to your site or app. Image Ads allow you to showcase your brand, product, or service with a single photo. You can provide your own images or ask our design team to create them for you. They're clearly marked as “Promoted”.`}
              isImageAd
              src='/images/common/image_ad.png'
            />
            <AdFormat
              title='Airdrop Ads'
              text={`Get your products out to the world with us. We will Airdrop your project's NFTs and tokens. These allow you to expand the reach of your projects beyond your followers to your desired target audience.`}
              src='/images/common/airdrop_ad.png'
            />
          </div>
          <AdContactBtnGroup />
        </div>
      </div>
      <AdInqueryFormModal />
    </VerticalNavDefaultPageTemplate>
  )
})

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['global', 'm'])),
    },
  }
}

export default AdInquiry
